import { JSONObject } from '../../types/types';
import { HandlerRequestContext } from '../../api/types/types';
import { resolveStringExpression } from '../json/resolveStringExpression';
import { resolveTemplate } from '../json/resolveTemplate';

// For output field handlers — resolves the trigger's `output` locally instead
// of calling an API method. A string is a JSONata expression, an object is a
// JSON template with {{ }} placeholders. Falls back to {} when the result is
// not a plain object so that merging into the host state is always safe.
export const executeOutputHandler = async (
  output: string | JSONObject,
  context: HandlerRequestContext
): Promise<Record<string, unknown>> => {
  const result =
    typeof output === 'string'
      ? await resolveStringExpression(output, context)
      : await resolveTemplate(output, context);

  // Anything that is not a plain object cannot map onto form fields.
  if (!result || typeof result !== 'object' || Array.isArray(result)) {
    return {};
  }

  return result as Record<string, unknown>;
};
